const DEFAULT_PAGE_SIZE = 40;

export { DEFAULT_PAGE_SIZE };
